import thunkMiddleware from 'redux-thunk';
import loggerMiddleware from 'redux-logger';
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootReducer from './rootReducer'
import authenticationMiddleware from './authenticationMiddleware'
// import reducerLoggerMiddleware from './loggerMiddleware'
import connectSignalRMiddleware from './connectSignalRMiddleware'


const persistConfig = {
  key: 'root23',
  storage,
  whitelist: ['departmentReducer', "kanbanReducer"],
}

const rootReducerWrapper = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined
  }

  return rootReducer(state, action)
}


const persistedReducer = persistReducer(persistConfig, rootReducerWrapper)


export function configureStoreDev(initStore, reduxRouterMiddleware) {
  const createStoreWithMiddleware = compose(
    applyMiddleware(
      thunkMiddleware, // lets us dispatch() functions
      loggerMiddleware,// neat middleware that logs actions
      authenticationMiddleware,
      // reducerLoggerMiddleware,
      connectSignalRMiddleware,
      reduxRouterMiddleware
    )
    // ,
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )(createStore);
  const store = createStoreWithMiddleware(persistedReducer, initStore);
  let persistor = persistStore(store)
  return { store, persistor }
}


export function configureStoreProd(initStore, reduxRouterMiddleware) {
  const createStoreWithMiddleware = applyMiddleware(
    thunkMiddleware, // lets us dispatch() functions
    authenticationMiddleware,
    // reducerLoggerMiddleware,
    connectSignalRMiddleware,
    reduxRouterMiddleware
  )(createStore);
  const store = createStoreWithMiddleware(persistedReducer, initStore);
  let persistor = persistStore(store)
  return { store, persistor }
}


// WEBPACK FOOTER //
// ./src/App/MainClient/storeConfiguration.js